<template lang="pug">

	b-modal(centered :hide-footer="true" :id="_id")

		template(slot="modal-title") Параметры участия

		div.text-success.mb-2(v-if="isSend")
			strong Вы будете перенаправлены на страницу участия через {{ okCountDown }} сек

		FormPpnt(:_event="_event" :_userID="account.data.id" :_cbOK="cbOK" :_htmlFormModel="regFormModel" :_submitText="'Зарегистрироваться'")

</template>
<script>
	import { mapState, mapActions } from 'vuex'

	import router from "@/router";
	import FormPpnt from '../FormPpnt'


	let regFormModel = [
		{name: 'promo_code', placeholder: "Промокод", type: "text",},
		{name: 'only_as_organizer', placeholder: "только как организатор группы", type: "checkbox"},
	];

	export default {
		name: 'eventsExtraDataModal',
		props: {
			_event: Object,
			_id: String,
		},
		components: {
			FormPpnt,
		},
		data: () => ({
			isSend: false,
			okCountDown: 5,
			regFormModel,
		}),
		computed: {
			...mapState(['myParticipants', 'events', 'account']),
		},
		methods: {
			...mapActions(['updateOneEvent']),

			cbOK(response) {
				const createdPpnt = response.data;

				this.isSend = true;
				this.$store.dispatch('updateOneEvent',{id:this._event.id,data: {is_participant:createdPpnt.id}});

				let interval = setInterval(() => {
					this.okCountDown > 0
						? this.okCountDown--
						: clearInterval(interval);
				}, 1000);

				setTimeout(() => {
					this.isSend = false;
					this.okCountDown = 5;
					this.$bvModal.hide(this._id);
					router.push({path: `/registrations/${createdPpnt.id}/#just-created`});
				}, 5000);
			},
		},
	}
</script>
